<template>
  <div class="rightOrder">
    <div class="topView">
      <div></div>
    <div>  结账明细 </div>  
       <div v-if="!selectShow" class="allcancle " @click="backStatus1" style="color:#0099ff;font-weight:500;cursor:pointer">返回</div>
    </div>
    <div class="mainView">
      <div style="border-bottom:1px solid #eaeaea">
        <el-table ref="multipleTable" @row-click='handleRowCliks' @selection-change="billOrderChange" :show-header="status" :data="billOrder" height="160px" :border="isborder" tooltip-effect="dark" style="width: 100%;border:none">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div style="color:#666;font-size:24px">{{ scope.row.dishesName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" width="120">
            <template slot-scope="scope" fixed="right">
              <div style="color:#FE852F;font-size:24px">￥{{ scope.row.discountPrice.toFixed(2) }}</div>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div>
        <el-table ref="list" @row-click='handleRowClik' @selection-change='handleSelectionChange' highlight-current-row @current-change="billListChange" :header-cell-style="{color:'#666',border:'none'}" height="277px" :data="billList" tooltip-effect="dark" style="width: 100%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="付款码" :show-overflow-tooltip='true' width="120">
            <template slot-scope="scope">{{ scope.row.productCode }}</template>
          </el-table-column>
          <el-table-column prop="productName" label="描述">
          </el-table-column>
          <el-table-column prop="productId" :show-overflow-tooltip='true' label="账号"></el-table-column>
          <el-table-column prop="billNo" label="流水单号" :show-overflow-tooltip='true' width="120"></el-table-column>
          <el-table-column label="金额" width="200" align="center">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.updataMoney" :placeholder="scope.row.totalPrice.toFixed(2)"> <i class="el-icon-edit el-input__icon" style=" font-size: 30px; line-height: 44px;" slot="suffix">
                </i></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" :show-overflow-tooltip='true'></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="selectFooter">
      <div class="footerTop">
        <div class="bz" style="padding: 20px 0">
          <span style="margin: 0 10px; color: #666">备注</span>

          <div class="beizhu">
            <el-input v-model="remark" type="textarea" :rows="6"></el-input>

          </div>
        </div>
        <div class="allPrice">
          <div style="color: #666">合计</div>
          <div class="totalPrice">{{totalRefundNum.toFixed(2)}}</div>
        </div>
      </div>
      <div class="footerBottom">
       <div></div>
        <div class="cvAndSD">

          <!-- <div v-if="!selectShow" class="jbBtn" style=" margin: 0 15px;" @click="Refund">退款</div> -->
          <div v-if="!selectShow" class="jbBtn" @click="undoCheckOut">撤销结账</div>
          <!-- 点击 @click="Refund"后        -->
          <div v-if="selectShow" class="blueBtn" style=" margin: 0 15px;">取消</div>
          <div v-if="selectShow" class="jbBtn">确认退款</div>
        </div>
      </div>
    </div>
    <el-dialog title="退款验证" :visible.sync="refund" width="720px">
      <div style="color:#666; font-size:24px;width:100%">
        <div class="refundItem">
          <div>退款菜品：</div>
          <div>
            <div v-for="(e,i) in refundList" :key="i">
              <div>
                <span>
                  {{e.dishesName}}
                </span>
                <span>
                  x{{e.quantity.toFixed(1)}}
                </span>
                <span style=" font-size: 24px; margin-right:4px">￥{{e.price.toFixed(2)}} </span>

              </div>

            </div>
          </div>

        </div>
        <div class="refundItem">
          <div>合计金额：</div>
          <div>
            ￥{{totalRefundNum.toFixed(2)}}
          </div>
        </div>
        <div class="refundItem">
          <div>退款方式：</div>
          <div>

            {{ billList.length > 1 ? paystatus.productName : billListChange[0]}}

          </div>
        </div>

      </div>
      <div style="color:#666; font-size:24px;margin:50px 0 15px 0">
        已向财务手机号{{strPhone}}发送验证码，请输入验证码
      </div>
      <div>
        <el-input v-model="refundinput" autocomplete="on"></el-input>
      </div>
      <div class="resend" @click="getPhoneCode">
        未收到验证码，重新发送
      </div>
      <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        " class="dialog-footer">
        <div>
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="refund = false">取 消</el-button>
          <el-button style="" type="primary" @click="verificationPhoneCode"> 确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog title="退款提示" :visible.sync="refundtips" width="720px">
      <div style="color:#F5581A; font-size:24px;width:100%;margin-top:50px">
        <div>此为线上支付退款 </div>
        <div>线上退款将直接由系统吧退款金额返还到支付账户，不用再线下付款。 </div>
        <div>线下支付请自行退款即可。 </div>
      </div>

      <div class="wxOne">
        <div class="tkWX">
          <span style="font-size:32px">￥234.00</span>
          <span>微信支付</span>
        </div>
        <div class="tkAll">
          <div class="tkItem" :class="wxtk == i ? 'tkitemCurrent' : '' " v-for="(v,i) in tuikuan" :key="i" @click="checkTK(i)"> {{v}} </div>
        </div>

      </div>

      <div class="zfbOne">
        <div class="tkzfb">
          <span style="font-size:32px">￥234.00</span>
          <span>支付宝支付</span>
        </div>
        <div class="tkAll">
          <div class="tkItem" :class="zfbtk == i ? 'tkitemCurrent' : '' " v-for="(v,i) in tuikuan" :key="i" @click="checkzfbTK(i)"> {{v}} </div>
        </div>

      </div>
      <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        " class="dialog-footer">
        <div>
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="refundtips = false">取 消</el-button>
          <el-button style="" type="primary">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    billList: {
      type: Array

    },
    billOrder: {
      type: Array
    }
  },
  data() {
    return {
      strPhone: '',
      number: '',
      refundinput: '',
      //退款验证弹窗
      refund: false,
      refundtips: false,
      // billList: [],
      // billOrder: [],
      paystatus: {},
      status: false,
      //退款操作状态
      selectShow: false,
      isborder: false,
      tuikuan: ['线上退款', '线下退款'],
      wxtk: 0,
      zfbtk: 0,
      nowID: '',
      refundList: [],
      totalRefundNum: 0,
      //财务电话
      phone: 123,
      selected: [],
      remark: "",
      id: ""
    }
  },
  created() {
    // this.billList = this.billList
    // this.billOrder = this.billOrder
  },
  
  mounted() {
    this.$bus.$on('orderRecordId', v => {
      this.id = v
    })
  },
  watch: {
    billList(val) {
      console.log(val);
      this.billList = val
    },
    billOrder(val) {
      this.billOrder = val
    },
    refundList(val) {
      this.totalRefundNum = 0;
      val.forEach((v, i) => {
        this.totalRefundNum += v.discountPrice
      })
    }
  },
  methods: {
    //loading
    loading(text) {
      const loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    handleRowClik(row, column, event) {
      this.$refs.list.toggleRowSelection(row);
    },
    handleRowCliks(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    handleSelectionChange(evt) {
      this.selected = evt
    },
    //付款方式
    billListChange(v) {
      this.paystatus = v
    },
    //选中菜品数组
    billOrderChange(v) {
      this.refundList = v
    },
    checkTK(i) {
      this.wxtk = i
    },
    checkzfbTK(i) {
      this.zfbtk = i
    },
    backStatus1() {
      this.$bus.emit('statuss', 1)

    },
    //退款按钮
    Refund() {
      console.log(this.refundList, this.totalRefundNum, this.billList.length, !this.paystatus);

      if (this.billList.length > 1 && Object.keys(this.paystatus).length == 0) {
        this.$notify.error({
          title: '请先选择付款方式'
        });
        return
      }

      if (this.refundList.length) {
        this.loading('加载中')
        this.refund = true;
        const url = this.api.bykey + '?key=POS_REFUND';
        const methods = 'get';
        this.$axios({ methods, url }).then(res => {
          console.log('财务电话', res.data);
          this.phone = res.data.data.value
          // this.phone = 18782881070;

          this.strPhone = res.data.data.value.substr(0, 3) + '****' + res.data.data.value.substr(7, res.data.data.value.split('').length);
          // console.log(strPhone);
          this.getPhoneCode()
        })


      } else {
        this.$notify.error({
          title: '请先勾选菜品'
        });


      }

    },
    // 发送验证码
    getPhoneCode() {

      const url = this.api.getPhoneCode + '?phone=' + this.phone
      this.$axios({ methods: 'get', url }).then(res => {
        console.log('手机发送验证码', res.data);
      })
    },
    // 验证验证码
    verificationPhoneCode() {

      if (!this.refundinput) {
        this.$notify.error({
          title: "请先输入验证码"
        });
        return
      }

      const orderBills = [], orderMenus = [];
      // let refundType = false;

      this.selected.map((res, index) => {
        const obj = {}
        obj.id = res.id
        obj.productId = res.productId
        obj.billType = res.billType
        obj.refundType = res.refundType
        obj.transactionId = res.transactionId
        obj.sweepPay = res.sweepPay

        if (res.updataMoney) {
          obj.totalPrice = res.updataMoney.tofixed(2)

        } else {
          obj.totalPrice = res.totalPrice
        }
        console.log('orderBills', obj);
        orderBills.push(obj)
      })
      this.refundList.map((res, index) => {
        const obj = {}

        obj.id = res.id
        obj.quantity = res.quantity
        obj.allPrice = res.allPrice
        console.log('orderMenus', obj);

        orderMenus.push(obj)

      })
      const flag = this.selected.length == this.billList.length ? true : false

      const refundTypes = this.billList.some(item => {

        if (item.updataMoney) {
          if (item.updataMoney != item.totalPrice) {
            return false
          }
        }
      });

      const refundType = refundTypes && flag ? true : false


      console.log(orderMenus, orderBills, refundType);
      let data = {
        orderRecordId: this.billList[0].orderRecordId,
        allPrice: this.totalRefundNum,
        refundType: refundType ? 'PART' : 'ALL',
        remark: this.remark,
        phone: this.phone,
        vcode: this.refundinput,
        orderMenus: orderMenus,
        orderBills: orderBills,
      }
      console.log(data);
      const url = this.api.refund
      this.$axios({ methods: 'post', url, data }).then(res => {
        console.log('验证码', res.data);
        if (res.data.status == 0) {
          this.refund = false;
          this.$notify.success({
            title: '退款成功'
          });

        } else {
          this.$notify.error({
            title: res.data.message
          });
          this.refundinput = ''
        }

      })
    },
    //撤销结账
    undoCheckOut() {
      this.loading('加载中')

      const url = this.api.revokePosBill + '?orderRecordId=' + this.id
      this.$axios({ methods: 'get', url }).then(res => {
        console.log('撤销结账', res.data);
        if (res.data.status == 0) {
          this.$message({
            message: "撤销成功",
            type: 'success'
          })

        }
      })

    }
  },
};
</script>

<style lang="scss" scoped>
.rightOrder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  .topView {
    flex: 0 0 66px;
    height: 66px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #eaeaea;
    align-items: center;
    font-size: 20px;
    color: #0099ff;
  }
  .mainView {
    width: 100%;
    height: 100%;
    position: relative;
    border-bottom: 1px solid #eaeaea;
    // height: 630px;
    flex: 1;
    overflow: auto;
    .hiddenTips {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 405%;
      left: 50%;
      transform: translate(-50%, -50%);
      .tips {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #bbe4ff;
        font-size: 28px;
        span {
          margin-top: 40px;
        }
      }
    }
    .selectItem {
      width: 100%;
      border-bottom: 1px solid #eaeaea;
      cursor: pointer;
      .selectTop {
        display: flex;
        padding: 30px 9px 0;
        .selectTopLeft {
          flex: 1;
          display: flex;
          align-items: center;
        }
        .selectNum {
          flex: 0 0 120px;
          display: flex;
          align-items: center;
          margin-right: 9px;
        }
      }
      .selectBottom {
        display: flex;
        align-items: center;
        padding: 0 9px;
        color: #666;
        justify-content: space-between;
        margin-top: 5px;
        .selectLeftBottom {
          display: flex;
          align-items: center;
          color: #666;
        }
        /deep/ .el-input__suffix {
          top: -3px !important;
        }
      }
      .funcBtn {
        display: flex;
        justify-content: space-between;
        padding: 0 10px 20px;
        .funcBtnItem {
          min-width: 41px;
          border-radius: 30px;
          color: #fff;
          font-size: 20px;
          padding: 7px 10px;
          background: #0099ff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .funcBtnItem:nth-child(2) {
          margin-right: 200px;
        }
      }
    }
    .selectItemCurrent {
      background: #edf8ff !important;
      border: 2px solid #0099ff;
    }
    .menuDetails {
      display: flex;
      flex-direction: column;
      overflow: auto;
      padding: 10px;
      .menudata {
        position: relative;
        width: 100%;
        height: 120px;
        background: #edf8ff;
        border-radius: 6px;
        display: flex;
        justify-content: space-between;
        .menuDataOneLeft {
          div {
            margin: 15px 20px;
            span:nth-child(1) {
              color: #999;
              margin-right: 20px;
            }
            span:nth-child(2) {
              color: #666;
            }
          }
        }
        .menuDataOneRight {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-right: 108px;
          span:nth-child(1) {
            color: #999;
            margin: 17px 0 20px;
          }
          span:nth-child(2) {
            color: #fe852f;
            font-size: 28px;
          }
        }
        .IImg {
          position: absolute;
          top: 0;
          right: 30px;
        }
      }
      .jtcaic {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .menuDataTwo {
        display: flex;
        justify-content: space-around;
        margin: 10px 0;
        .menuDataTwoItem {
          width: 19%;
          height: 100px;
          background: #ffffff;
          border-radius: 6px;
          border: 1px solid #eaeaea;
          display: flex;
          flex-direction: column;
        }
      }
      .menuDataThreeAndFour {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin: 0 0 10px;

        .menuDataThreeAndFourItem {
          width: 19%;
          margin-bottom: 10px;
          height: 100px;
          background: #e7e8f1;
          border-radius: 6px;
          border: 1px solid #eaeaea;
          display: flex;
          flex-direction: column;
        }
      }
      .menuDataFive {
        display: flex;
        margin: 0 0 10px;
        justify-content: space-around;
        .menuDataFiveLeft {
          // width: 322px;
          flex: 0 0 322px;
          font-size: 20px;
          div {
            width: 100%;
          }
          div:nth-child(1) {
            height: 100px;
            border: 6px;
            background: #e7e8f1;
            border-radius: 6px;
            border: 1px solid #eaeaea;
            margin-bottom: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          div:nth-child(2) {
            height: 60px;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666;
          }
        }
        .menuDataFiveRight {
          flex: 1;
          margin-left: 10px;
          height: 170px;
          background: #e7e8f1;
          border-radius: 6px;
          border: 1px solid #eaeaea;
          font-size: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          span:nth-child(1) {
            color: #999;
            margin: 16px 0 12px;
          }
          span:nth-child(2) {
            color: #666;
          }
        }
      }
    }
  }
  .selectFooter {
    flex: 0 0 243px;
    display: flex;
    flex-direction: column;
    .footerTop {
      display: flex;
      border-bottom: 1px solid #eaeaea;
      .bz {
        flex: 1;
      }
      .beizhu {
        margin: 15px 10px 20px 20px;
        color: #666666;
        font-weight: 500;
      }
      .allPrice {
        flex: 0 0 215px;
        padding: 20px 7px;
        border-left: 1px solid #eaeaea;
        .totalPrice {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          font-size: 36px;
          color: #fe8d30;
        }
      }
    }

    .footerBottom {
      flex: 0 0 79px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .blueBtn {
        width: 140px;
        height: 60px;
        background: #0099ff;
        color: #fff;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
        border-radius: 38px;
        margin-right: 10px;
        cursor: pointer;
      }
      .jbBtn {
        width: 140px;
        cursor: pointer;
        height: 60px;
        background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
        box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
        border-radius: 38px;
        color: #fff;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
      }
      .cvAndSD {
        display: flex;
      }
    }
  }
  .refundItem {
    display: grid;
    grid-template-columns: 120px 1fr;
    margin: 10px 0;
  }
  .resend {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0099ff !important;
    width: 200px;
    margin: 30px auto;
  }
}
.wxOne {
  display: flex;
  margin: 40px 0;
  align-items: center;
  .tkWX {
    display: flex;
    flex-direction: column;
    color: #333;
    width: 200px;
  }
}
.zfbOne {
  display: flex;
  margin: 40px 0;
  align-items: center;
  .tkzfb {
    display: flex;
    flex-direction: column;
    color: #333;
    width: 200px;
  }
}
.tkAll {
  display: flex;
  .tkItem {
    width: 190px;
    height: 66px;
    background: #eeeeee;
    border-radius: 6px;
    line-height: 66px;
    text-align: center;
    margin: 0 0 0 30px;
    color: #666;
    font-size: 24px;
    cursor: pointer;
  }
  .tkitemCurrent {
    color: #fff;
    background: #0099ff;
  }
}
</style>
<style lang="scss" scoped>
.el-table {
  font-size: 20px;
  /deep/.el-input__inner {
    border: none;
    padding: 0;
    // line-height: 0 !important;
    height: 40px;
    font-size: 30px;
    color: #000;
    background: #eee;
    text-align: center;
  }
}
/deep/ .el-table__header-wrapper .el-checkbox {
  display: none;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: transparent;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: transparent;
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
/deep/.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
/deep/.el-dialog__body {
  width: 100%;
  padding: 0 60px;
}

/deep/.el-input__inner {
  border: none;
  padding: 0;
  // line-height: 0 !important;
  height: 120px;
  font-size: 60px;
  color: #666;
  background: #eee;
  text-align: center;
}
.beizhu /deep/ .el-input__inner {
  font-size: 30px;
  text-align: left;
}
</style>